import React from 'react';

const DischargePapersDescription = (
  <>
    <p>
      We recommend uploading any supporting documents that may help us confirm
      details about your military service.
    </p>
    <p>
      It’s your choice whether to upload them. But they may help us process your
      form faster.
    </p>
    <h2 className="vads-u-font-size--h3">Military service documents</h2>
    <p>You can upload copies of any of these documents:</p>
    <ul>
      <li>Your DD214, DD215, or other separation documents</li>
      <li>
        Military service records or documents, like proof of military awards or
        your disability rating letter
      </li>
      <li>Military orders or unit histories</li>
    </ul>
    <p>
      <strong>Note:</strong> If you have more than 1 discharge document, upload
      the document with the highest character of discharge.
    </p>
  </>
);

export default DischargePapersDescription;
